import React, { useState, useEffect } from 'react';
import moment from 'moment';
import '../../styles/moduledash.css';
import { useNavigate } from 'react-router-dom';
import {
	FiCalendar,
	FiZap,
	FiTarget,
	FiArrowRight,
	FiAward,
	FiSearch,
	FiChevronRight,
} from 'react-icons/fi';
import { BsInfoCircle } from 'react-icons/bs';

import { AiFillStar } from 'react-icons/ai';

import { SiGoogleclassroom } from 'react-icons/si';
import { useSelector, useDispatch } from 'react-redux';
import {
	fetchCourseData,
	fetchRecordings,
	setMeetingId,
} from '../../redux/course/courseSlice';
import {
	fetchAllModules,
	fetchModuleQuestions,
	handleSwitch,
	updateModules,
	selectActiveModule,
} from '../../redux/modules/moduleSlice';
import LectureAndNotes from './LectureAndNotes';
import DoubtRecording from './DoubtRecording';
import CourseDropDown from '../../components/CourseDropDown';
import Loader from '../../components/Loader';
import { services } from '../../apis';
import { engagements } from '../../engagements';

const ModulesDash = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const userState = useSelector((state: any) => state.user);
	const { user } = userState;

	const instructor =
		user !== null
			? user.roles.find((role: any) => role == 'instructor')
			: undefined;
	const role = instructor !== undefined ? 1 : 0;

	const moduleState = useSelector((state: any) => state.module);
	const {
		allModulesData,
		modulesData,
		allModules,
		moduleListloading,
		moduleloading,
	} = moduleState;

	const courseState = useSelector((state: any) => state.course);
	const {
		latestAssignment,
		courseID,
		course,
		allCourses,
		courseName,
		recordingDataLecture,
		recordingDataDoubt,
		totalAssignmentQuestions,
		totalSolvedAssignmentQuestions,
		upcomingMeetings,
		latestAssignmentData,
		upcomingClass,
	} = courseState;

	const [modulesList, setModulesList] = useState<any[]>([]);
	const [questionsList, setQuestionList] = useState<any[]>([]);
	// const [devQuestionsList, setDevQuestionList] = useState<any[]>([]);
	const [webDevQuestionList, setWebDevQuestionList] = useState<any[]>([]);
	const [showAptitudeCard, setShowAptitudeCard] = useState<any[]>([]);
	const [curModuleID, setCurModuleID] = useState('');
	const [moduleName, setModuleName] = useState('');
	const [componentArray, setComponentArray] = useState<number[]>([0, 1, 0]);
	const [isWebModule, setIsWebModule] = useState(false);
	const [isAptitudeModule, setIsAptitudeModule] = useState(false);
	const [totalScore, setTotalScore] = useState(0);
	const [totalEarnedScore, setTotalEarnedScore] = useState(0);

	// const [courseName, setCourseName] = useState('');

	useEffect(() => {
		if (courseID !== null) {
			console.log('MODULE COURSE ID ', courseID);
			if (allModules[courseID] === undefined) {
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				dispatch(fetchAllModules(courseID));
			} else {
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				dispatch(handleSwitch);
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				dispatch(updateModules(courseID));
			}
		}
	}, [courseID]);

	// useEffect(() => {
	// 	if (courseName !== null) setCourseName(courseName);
	// }, [courseName]);

	const [countOfUserModules, setCountOfUserModules] = useState(0);

	const [isShowUserModuleSet, setIsShowUserModuleSet] = useState(false);

	useEffect(() => {
		if (allModulesData !== null) {
			setIsShowUserModuleSet(false);
			console.log('ALL MODULES', allModulesData.assignmentModules);
			const temp = [...allModulesData.assignmentModules];
			temp.sort(function (a: any, b: any) {
				return moment(a.startDate) > moment(b.startDate) ? -1 : 1;
			});
			setModulesList(temp);
			const ts =
				allModulesData.totalCodingQuestionsScore +
				allModulesData.totalWebDevQuestionsScore +
				allModulesData.totalConceptualQuestionsScore;
			const tes =
				allModulesData.solvedCodingQuestionsScore +
				allModulesData.solvedWebDevQuestionsScore +
				allModulesData.solvedConceptualQuestionsScore;
			setTotalScore(ts);
			setTotalEarnedScore(tes);
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			const elem = document.getElementById('module-mid-head');
			console.log('elem', elem);

			if (elem !== null) {
				elem.addEventListener('mouseover', () => {
					console.log('mouseover hit');
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					const childElem = document.getElementById('bifurcation');
					console.log('childElem', childElem);
					if (childElem !== null) {
						childElem.style.opacity = '1';
						childElem.style.zIndex = '50';
					}
				});
				elem.addEventListener('mouseleave', () => {
					console.log('mouseover hit');
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					const childElem = document.getElementById('bifurcation');
					console.log('childElem', childElem);
					if (childElem !== null) {
						childElem.style.opacity = '0';
						childElem.style.zIndex = '-1';
					}
				});
			}
		}
	}, [allModulesData]);

	const filterUserModules = () => {
		if (isShowUserModuleSet) {
			setIsShowUserModuleSet(false);
			const temp = [...allModulesData.assignmentModules];
			temp.sort(function (a: any, b: any) {
				return moment(a.startDate) > moment(b.startDate) ? -1 : 1;
			});
			setModulesList(temp);
		} else {
			const temp = allModulesData.assignmentModules.filter(
				(el: any) => el.idUserModule
			);

			temp.sort(function (a: any, b: any) {
				return moment(a.startDate) > moment(b.startDate) ? -1 : 1;
			});

			setModulesList(temp);

			setIsShowUserModuleSet(true);
		}
	};

	useEffect(() => {
		if (latestAssignment !== null && latestAssignmentData !== null) {
			selectModule(
				latestAssignment,
				latestAssignmentData.module.type,
				latestAssignmentData.module.name
			);
			// setModuleName(modulesData[curModuleID].module.name);
		}
	}, [courseID]);

	useEffect(() => {
		if (curModuleID !== '' && modulesData[curModuleID] !== undefined) {
			console.log('moduledata', modulesData[curModuleID]);
			setQuestionList(modulesData[curModuleID].codingQuestions);
			setWebDevQuestionList(modulesData[curModuleID].webdevQuestions);
			setIsAptitudeModule(
				modulesData[curModuleID].conceptualQuestions.length > 0
			);
			setIsWebModule(
				modulesData[curModuleID].module.type === 'WEB_ASSIGNMENT'
			);
			setModuleName(modulesData[curModuleID].module.name);
			console.log('current', modulesData[curModuleID].module);
			selectActiveModule(modulesData[curModuleID].module);
		}
	}, [curModuleID]);

	const selectModule = async (
		moduleID: string,
		type: string,
		name: string
	) => {
		console.log('Type', type);
		if (modulesData[moduleID] === undefined) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			await dispatch(fetchModuleQuestions(moduleID));
		}
		componentToggler(1);
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		await dispatch(fetchRecordings(moduleID));
		setCurModuleID(moduleID);
		console.log('Questions', questionsList);
	};

	const colorMap = (num: number): any => {
		const color = [
			{
				color: 'rgba(239,87,76,0.5)',
				bg: '#FDE6E4',
			},
			{
				color: '#FF940A',
				bg: 'rgba(255, 239, 218, 0.5)',
			},
			{
				color: '#12B76A',
				bg: 'rgba(227, 255, 237, 0.5)',
			},
		];
		if (num < 0.5) {
			return color[0];
		} else if (num >= 0.5 && num < 0.8) {
			return color[1];
		} else if (num >= 0.8) {
			return color[2];
		}
	};

	const colorDIFFMap = (diff: string): any => {
		const color = [
			{
				color: '#EF574C',
				bg: '#FDE6E4',
			},
			{
				color: '#F0B416',
				bg: 'rgba(253, 242, 214, 0.5)',
			},
			{
				color: '#12B76A',
				bg: '#E3FFED',
			},
		];
		if (diff === 'HARD') {
			return color[0];
		} else if (diff === 'MEDIUM') {
			return color[1];
		} else if (diff === 'EASY') {
			return color[2];
		}
	};

	const componentToggler = (num: number) => {
		const temp = [...componentArray];
		for (let i = 0; i < 3; i++) temp[i] = num === i ? 1 : 0;
		console.log(temp);
		setComponentArray([...temp]);
	};

	// const [moduleFilteredList, setModuleFilteredList] = useState([]);

	const searchInModules = (e: any) => {
		const temp = e.toLowerCase();
		const filteredData = allModulesData.assignmentModules.filter(
			(el: any) => el.name.toLowerCase().includes(temp)
		);
		// if (e === '') {
		// 	setModulesList(allModulesData.assignmentModules);
		// }
		setModulesList(filteredData);
		console.log('FILTER', filteredData);
	};

	const startZoomMeeting = async (meetingId: string) =>
		await services.courseService.fetchStartUrl(meetingId);
	const startZoomMeetingForStudents = async (meetingId: string) =>
		await services.courseService.fetchStartUrlForStudents(
			meetingId,
			user.firstName,
			user.lastName,
			user.email
		);

	const setZoomMeetingId = (
		meetingId: string,
		start_url: string,
		title: string
	) => {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		dispatch(setMeetingId(meetingId));
		const myWindow = window.open('', new Date().getTime().toString());
		if (role === 0) {
			// window.open(
			// 	`${window.origin}/liveclass?meetingId=${meetingId}`,
			// 	'_blank'
			// );

			startZoomMeetingForStudents(meetingId)
				.then((res) => {
					engagements.courseEngagement.joinClass(title, meetingId);
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					//@ts-ignore
					myWindow.location.href = res.join_url;
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					//@ts-ignore
					myWindow.focus();
				})
				.catch((e) =>
					alert(
						'Some error occured in joining the class. Please try again'
					)
				);
		} else {
			startZoomMeeting(meetingId)
				.then((res) => {
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					//@ts-ignore
					myWindow.location.href = res;
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					//@ts-ignore
					myWindow.focus();
				})
				.catch((e) =>
					alert(
						'Some error occured in joining the class. Please try again'
					)
				);
		}
	};

	return (
		<div className={'module-dash'}>
			<div className={'module-menu'}>
				<div className={'dropdown'}>
					<CourseDropDown />
				</div>
				<div className={'module-list'}>
					<div className={'search-module'}>
						<FiSearch />
						<input
							className={'search-module-input'}
							placeholder={'Search any topic'}
							onChange={(event) =>
								searchInModules(event.target.value)
							}
						/>
					</div>
					<div className={'module-mid-head'}>
						{allModulesData !== null ? (
							<>
								<div
									className={'course-assignment-status'}
									id={'module-mid-head'}
								>
									Total Assignments Score : {totalEarnedScore}
									/{totalScore}
									{'  '}
									<BsInfoCircle />
								</div>
								<div
									className={'bifurcation'}
									id={'bifurcation'}
								>
									<ul>
										<li>
											Coding Score :
											<span>
												{
													allModulesData.solvedCodingQuestionsScore
												}
												/
												{
													allModulesData.totalCodingQuestionsScore
												}
											</span>
										</li>
										<li>
											WebDev Score :
											<span>
												{
													allModulesData.solvedWebDevQuestionsScore
												}
												/
												{
													allModulesData.totalWebDevQuestionsScore
												}
											</span>
										</li>
										<li>
											Conceptual Score :
											<span>
												{
													allModulesData.solvedConceptualQuestionsScore
												}
												/
												{
													allModulesData.totalConceptualQuestionsScore
												}
											</span>
										</li>
									</ul>
								</div>
							</>
						) : null}
					</div>

					<div className={'module-list-container'}>
						<ul>
							{!moduleListloading ? (
								modulesList.length === 0 ? (
									<p className={'no-module'}>
										No Module Available
									</p>
								) : (
									modulesList.map((el: any) => {
										const type = el.type;
										const name = el.name;
										return (
											<li
												className={`${
													el.id === curModuleID
														? 'active-module'
														: ''
												}`}
												key={el.id}
												onClick={() => {
													selectModule(
														el.id,
														type,
														name
													);
												}}
												style={{
													backgroundImage: `linear-gradient( to right, ${
														el.id !== curModuleID
															? colorMap(
																	el.totalQuestions !==
																		0
																		? el.solved /
																				el.totalQuestions
																		: 1
															  ).bg
															: '#ebf3fe'
													} ${
														(el.totalQuestions !== 0
															? el.solved /
															  el.totalQuestions
															: 1) * 100
													}% , #fff 
                    ${1}%
                      )`,
													// backgroundSize: `${(el.solved / el.totalQuestions) * 100}%`,
												}}
											>
												<div className={'module-info'}>
													<p className={'date'}>
														{moment(
															el.startDate
														).format('DD MMMM')}
													</p>
													<h3
														className={
															'module-name'
														}
													>
														{el.name}
													</h3>
												</div>
												<div
													className={'completed'}
													style={{
														color: `${
															el.id !==
															curModuleID
																? colorMap(
																		el.totalQuestions !==
																			0
																			? el.solved /
																					el.totalQuestions
																			: 1
																  ).color
																: '#2666BE'
														}`,
													}}
												>
													{el.solved}/
													{el.totalQuestions}{' '}
													Completed
													{el.id === curModuleID ? (
														<FiChevronRight />
													) : null}
												</div>
												{el.idUserModule ? (
													<div
														className={
															'user-module-banner'
														}
														title={
															'These are the special modules that are specific to you'
														}
													>
														<AiFillStar />
													</div>
												) : null}
											</li>
										);
									})
								)
							) : (
								<Loader />
							)}
						</ul>
					</div>
				</div>
			</div>
			<div className={'module-data'}>
				<div className={'top-bar'}>
					<div className={'topic-name'}>
						{!moduleListloading ? (
							<>
								<p className={'course-name'}>{courseName}</p>
								<h3 className={'active-module-name'}>
									{moduleName}
								</h3>
							</>
						) : (
							<Loader />
						)}
					</div>
					{upcomingClass !== null ? (
						<button
							className={'calendar-btn'}
							disabled={!(new Date() > upcomingClass.activeAt)}
							onClick={() =>
								setZoomMeetingId(
									upcomingClass.room,
									upcomingClass.url,
									upcomingClass.name
								)
							}
						>
							<SiGoogleclassroom />
							Join Class
						</button>
					) : null}
				</div>
				<div className={'module-content'}>
					<ul className={'module-content-switch'}>
						<li
							className={componentArray[1] === 1 ? 'active' : ''}
							onClick={() => componentToggler(1)}
						>
							Assignment
						</li>
						{recordingDataLecture !== null ? (
							<li
								className={
									componentArray[0] === 1 ? 'active' : ''
								}
								onClick={() => componentToggler(0)}
							>
								Lectures
							</li>
						) : null}

						{recordingDataDoubt !== null ? (
							<li
								className={
									componentArray[2] === 1 ? 'active' : ''
								}
								onClick={() => componentToggler(2)}
							>
								Homework Discussion
							</li>
						) : null}
					</ul>
					<div className={'module-content-container'}>
						{componentArray[0] === 1 ? <LectureAndNotes /> : null}
						{componentArray[2] === 1 ? <DoubtRecording /> : null}
						{componentArray[1] === 1 ? (
							questionsList.length > 0 ||
							webDevQuestionList.length > 0 ||
							isAptitudeModule ? (
								<ul className={'assignments'}>
									{modulesData[curModuleID]
										.conceptualQuestions.length > 0 ? (
										<li
											className={'question aptitude-card'}
											key={'aptitude-questions'}
										>
											<div className={'question-info'}>
												<div
													className={
														'question-details'
													}
												>
													<h4>
														Solve Conceptual
														Questions
													</h4>
												</div>
												<button
													className={
														'question-solve-btn'
													}
													onClick={() =>
														navigate(
															`/aptitude?moduleId=${curModuleID}`
														)
													}
												>
													Start Solving
													<FiArrowRight />
												</button>
											</div>
										</li>
									) : null}
									{!moduleloading ? (
										questionsList.map((el) => (
											<li
												key={el.id}
												className={'question'}
											>
												<div
													className={'question-info'}
												>
													<div
														className={
															'question-details'
														}
													>
														<h4>{el.title}</h4>
														<ul>
															<li>
																<FiZap />
																<span
																	className={
																		'difficulty'
																	}
																	style={{
																		color: colorDIFFMap(
																			el.difficulty
																		).color,
																		backgroundColor:
																			colorDIFFMap(
																				el.difficulty
																			)
																				.bg,
																	}}
																>
																	{
																		el.difficulty
																	}
																</span>
															</li>
															<li>
																<FiTarget /> Max
																Score:{' '}
																{el.score}{' '}
																Points
															</li>
															<li>
																<FiAward />
																Your Score:{' '}
																{
																	el.userScore
																}{' '}
																Points
															</li>
														</ul>
													</div>
													<button
														className={`${
															el.solved
																? 'question-solved-btn'
																: 'question-solve-btn'
														}`}
														onClick={() =>
															window.open(
																`${window.origin}/idle?question=${el.id}`,
																'_blank'
															)
														}
													>
														{' '}
														{el.solved ? (
															<>Solved</>
														) : (
															<>
																Start Solving
																<FiArrowRight />
															</>
														)}
													</button>
												</div>
											</li>
										))
									) : (
										<Loader />
									)}
									{!moduleloading
										? webDevQuestionList.map((el) => (
												<li
													key={el.id}
													className={'question'}
												>
													<div
														className={
															'question-info'
														}
													>
														<div
															className={
																'question-details'
															}
														>
															<h4>{el.title}</h4>
															<ul>
																<li>
																	<FiZap />
																	<span
																		className={
																			'difficulty'
																		}
																		style={{
																			color: colorDIFFMap(
																				el.difficulty
																			)
																				.color,
																			backgroundColor:
																				colorDIFFMap(
																					el.difficulty
																				)
																					.bg,
																		}}
																	>
																		{
																			el.difficulty
																		}
																	</span>
																</li>
																<li>
																	<FiTarget />{' '}
																	Max Score:{' '}
																	{el.score}{' '}
																	Points
																</li>
																<li>
																	<FiAward />
																	Your Score:{' '}
																	{
																		el.userScore
																	}{' '}
																	Points
																</li>
															</ul>
														</div>
														<button
															className={`${
																el.solved
																	? 'question-solved-btn'
																	: 'question-solve-btn'
															}`}
															onClick={() =>
																window.open(
																	`${window.origin}/web-idle?question=${el.id}`,
																	'_blank'
																)
															}
														>
															{' '}
															{el.solved ? (
																<>Solved</>
															) : (
																<>
																	Start
																	Solving
																	<FiArrowRight />
																</>
															)}
														</button>
													</div>
												</li>
										  ))
										: null}
								</ul>
							) : isAptitudeModule ? null : (
								<p>No Questions Available For Today</p>
							)
						) : null}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ModulesDash;
